import Vue from 'vue'
import App from './App'
import 'swello-components/dist/swello-components.css'
import { SwelloPlugin } from 'swello-components'
import 'vue-progress-path/dist/vue-progress-path.css'
import VueProgress from 'vue-progress-path'
import './style/main.styl'
import store from './model/store/index'
import Sortable from 'vue-sortable'

Vue.config.productionTip = false
Vue.use(SwelloPlugin)
Vue.use(Sortable)
Vue.use(VueProgress)
/* eslint-disable no-new */
let u = new Vue({
  el: '#app',
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js